import React from 'react';
import meImage from '../photos/me1.jpg'

function About(){
 return(
  <>
   <Section1 />
  </>

 )
}

const Section1 = () =>{
 return(
    <div style={{minHeight: "91vh"}}>
       <div className = "container fontBody firstSection" style={{paddingTop:"15vh", display: "flex", justifyContent: "space-evenly", paddingBottom: "5vh"}}>
        <div>
            <h1 style={{fontSize: "3vw"}}>Yinuo "Eva" Hu</h1>
            <h4 style={{fontSize: "1.5vw"}}>Master of Analytics @UCBerkeley, IEOR (2022-2023)</h4>
            <h4 style={{fontSize: "1.5vw"}}>Bachelor of Science in Computer Science & Sociology @UNC-Chapel Hill (2018-2022)</h4>
            <p style={{fontSize: "1.2vw", width: "55vw"}}
            > With my previous experiences as a product manager, full-stack software
            engineer, and NLP researcher across different projects and interns, I am familiar with product design, product management, and building, and deploying tech products.</p>
        </div>
        <img style={{width: "30%"}}src={meImage}/>
        </div>
  
        <div className="fontBody" style={{paddingLeft: '15vw', paddingRight:'15vw', marginBottom:'5vh'}}>
            <h4 style={{fontSize: "2vw"}}>My Passion</h4>
            <p style={{fontSize: "1.2vw"}}>
            I'm passionate about <b>developing innovative and tech-enhanced products that brings both business values and positive social impacts</b>. With a educational backgrond of computer science and sociology, I have developed a sociological perspective to view and analyze real-world social phenomena, while hoping to utilize technology to help resolve some current social conflicts or to help those in needs. Technology should be more than merely chasing for higher quality and higher efficiency, the concerning of humanity aspects should be reminded and emphasized. 
            </p>
        </div>

        <div className="fontBody" style={{paddingLeft: '15vw', paddingRight:'15vw', marginBottom:'5vh'}}>
            <p style={{fontSize: "1.2vw"}}><strong>Email: </strong>evahuyn@berkeley.edu | eva.yinuohu@gmail.com
            </p>
            <p style={{fontSize: "1.2vw"}}><strong>Wechat: </strong>Eva_HUyn</p>
        </div>
     </div>

 );
}

export default About;